import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { IConstructionType } from 'types/constructionTypes';
import { trackDatadogRumError } from 'utils/initDatadogRum';

const getConstructionTypes = async (): Promise<IConstructionType[]> => {
    const response = await axiosInstance.get<IConstructionType[]>(API_ENDPOINTS.CONSTRUCTION_TYPES);
    if (!Array.isArray(response.data)) {
        trackDatadogRumError(
            new Error('[useGetConstructionTypes] Expected array response'),
            { receivedType: typeof response.data, receivedValue: response.data },
        );
        return [];
    }
    return response.data;
};

export const useGetConstructionTypes = (
    options?: Omit<UseQueryOptions<IConstructionType[]>, 'queryKey' | 'queryFn'>,
) => useQuery<IConstructionType[], Error>({
    queryKey: [QUERY_KEYS.CONSTRUCTION_TYPES],
    queryFn: () => getConstructionTypes(),
    staleTime: Infinity,
    ...(options ?? {}),
});
